<template>
  <div>
    <header-ton @boxLogin="IsUsersLogin" :actived="1"></header-ton>
    <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
    <column-box @setSubject="setBoxSubject" :showColumn="showColumn" :classId="class_id" :columnId="column_id"
      :subjectId="subject_id" @closeColumn="closeBoxColumn" ref="column"></column-box>
    <buy-vip-box :showVip="showVip" @closeLogin="closeVipBox" :vipData="vipData"></buy-vip-box>
    <div class="chapter">
      <div class="c_left">
        <div class="title">考试方向</div>
        <div class="meaus">
          <div :class="class_id == item.id ? 'li active' : 'li'" @click="getColumn(item.id)"
            v-for="(item, index) in classData" :key="index">
            <img :src="item.thumb" width="24" height="24" />
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="c_right" v-loading="loading" element-loading-text="数据加载中">
        <header class="home_header">
          <div class="context_box">
            <b>{{ columnName }}</b>
            <span>{{ subjectName }}</span>
            <div class="check_box" @click="changeColumn">
              <div class="el-dropdown">
                <p class="el-dropdown-selfdefine">
                  <i>切换</i>
                  <span></span>
                </p>
              </div>
            </div>
          </div>
        </header>

        <div class="mk_conbox">
          <div class="tab_nav">
            <div class="li active">章节练习</div>
            <!-- <div class="li">历年真题</div>
            <div class="li">模考密卷</div>-->
            <div class="li" @click="goMeco" v-if="column_id == 32">机考系统</div>
            <div class="li" @click="goGuide" v-if="column_id == 75">机考系统</div>
            <div class="li" @click="goCes" v-if="column_id == 65">机考系统</div>
            <div class="li" @click="goCes" v-if="column_id == 66">机考系统</div>
            <div class="li" @click="goCes" v-if="column_id == 6">机考系统</div>
            <div class="li" @click="goCes" v-if="column_id == 77">机考系统</div>
            <div class="li" @click="goDoc" v-if="column_id == 60">机考系统</div>
            <div class="li" @click="goMeco" v-if="column_id == 30">机考系统</div>
            <div class="li" @click="goYiwei" v-if="column_id == 61">机考系统</div>
            <div class="li" @click="goWater" v-if="column_id == 101">机考系统</div>
          </div>

          <!-- 章节练习 -->
          <div class="tab-list">
            <li>
              <ul class="subject clearfix">
                <li class="w1" style="text-align: left;">
                  <span style="padding-left: 20px; ">章节</span>
                </li>
                <li class="w3">正确率</li>
                <li class="w2">做题进度</li>
                <li class="w4"></li>
              </ul>
            </li>

            <div v-for="(item, index) in chapterData" :key="index">
              <li class="li_list">
                <ul class="bd cur clearfix" @click="selectChange(item.id)">
                  <li class="w1 f-lf level-0 pro_zhang_infoTit" data-id="yc_da_77">
                    <em :class="selected == item.id ? ' develop unwind' : 'develop'"></em>
                    <a :title="item.title">
                      <i>
                        {{ item.title }}
                      </i>
                    </a>
                  </li>
                  <li class="w3"></li>
                  <li class="w3"></li>
                  <li class="w2"></li>
                  <li class="w4" style="font-size: 14px;color: #666;padding-right: 15px;">{{ item.numss }}题</li>
                </ul>
              </li>
              <div id="yc_da_77" :style="selected == item.id ? '' : ' display: none;'">
                <ul class="bd clearfix" v-for="(items, index) in item.childs" :key="index">
                  <li class="w1 f-lf level-1">
                    <a :title="items.title">
                      <em class="no-underclass"></em>
                      <i>{{ items.title }}</i>
                    </a>
                  </li>
                  <li class="w3">{{ items.correct }}%</li>
                  <li class="w2">{{ items.do }}/{{ items.nums }}</li>
                  <li class="w4">
                    <el-button type="success" v-if="items.is_free == 0" @click="doChapter(items.id)"
                      icon="el-icon-edit-outline" size="small">做题</el-button>
                    <el-button type="danger" v-else @click="lockChapter(items.column_id)" icon="el-icon-lock"
                      size="small">解锁</el-button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <booter-ton></booter-ton>
  </div>
</template>


<script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
import LoginBox from "@/components/LoginBox";
import BuyVipBox from "@/components/BuyVipBox";
import ColumnBox from "@/components/ColumnBox";

export default {
  components: {
    HeaderTon,
    BooterTon,
    LoginBox,
    BuyVipBox,
    ColumnBox,
  },
  data() {
    return {
      loading: true,
      subject_id: 0,
      selected: 0,
      class_id: 1,
      column_id: 0,
      subject_id: 0,
      columnName: '',
      subjectName: '',
      showLogin: false,
      showVip: false,
      showColumn: false,
      keywords: "",
      classData: [],
      columnData: [],
      subjectData: [],
      chapterData: [],
      vipData: [],
    };
  },
  mounted() {
    var that = this;
    let class_id = sessionStorage.getItem("access-class_id");
    let column_id = sessionStorage.getItem("access-column_id");
    let subject_id = sessionStorage.getItem("access-subject_id");
    console.log(class_id);
    if (class_id == '' || class_id == null) {
      class_id = 1;
    }
    that.class_id = Number(class_id);
    if (column_id == '' || column_id == null) {
      column_id = 5;
    }
    if (subject_id == '' || subject_id == null) {
      subject_id = 8;
    }
    that.subject_id = Number(subject_id);
    that.column_id = Number(column_id);
    this.getList();
  },
  methods: {

    setBoxSubject(e) {
      console.log(e);
      this.column_id = e.column_id;
      this.subject_id = e.subject_id;
      this.showColumn = false;
      this.getChapterList();
    },

    getColumn(e) {
      console.log(e);
      this.class_id = e;
      this.$refs.columnId = e;
      this.showColumn = true;
      sessionStorage.setItem("access-class_id", e);
    },

    //获取一级分类
    getList() {
      let that = this;
      let formData = {};
      formData.column_id = that.column_id;
      formData.limit = that.limit;
      that.axios.post("/getColumnCate", formData).then((res) => {
        if (res) {
          that.classData = res.data;
          that.getChapterList();
        }
      });
    },

    selectChange(e) {
      console.log(e);
      if (this.selected == e) {
        this.selected = 0;
      } else {
        this.selected = e;
      }
    },

    changeColumn() {
      this.showColumn = true;
      this.$refs.column.getColumnList();
    },

    //判断是否登录
    IsUsersLogin() {
      let token = sessionStorage.getItem("access-token");
      console.log(token);
      if (token) {
        return true;
      } else {
        this.showLogin = true;
        this.$refs.login.getMiQrCode();
        return false;
      }
    },

    doChapter(ids) {
      if (this.IsUsersLogin()) {
        this.$router.push({
          path: "/web/mock_chapter",
          query: {
            chapter_id: ids,
          },
        });
      }
    },

    goMeco() {
      if (this.IsUsersLogin()) {
        this.$router.push({
          path: "/meco/index",
          query: {
            column_id: this.column_id,
            subject_id: this.subject_id
          },
        });
      }
    },

    goWater() {
      if (this.IsUsersLogin()) {
        this.$router.push({
          path: "/meco/index",
          query: {
            column_id: this.column_id,
            subject_id: this.subject_id
          },
        });
      }
    },

    goYiwei() {
      if (this.IsUsersLogin()) {
        this.$router.push("/meco/yiwei/index");
      }
    },

    goAccount() {
      if (this.IsUsersLogin()) {
        this.$router.push({
          path: "/guide/account/login",
          query: {
            column_id: this.column_id,
            subject_id: this.subject_id
          },
        });
      }
    },

    goDoc() {
      if (this.IsUsersLogin()) {
        this.$router.push({
          path: "/doctor/index",
          query: {
            column_id: this.column_id,
            subject_id: this.subject_id
          },
        });
      }
    },

    goGuide() {
      if (this.IsUsersLogin()) {
        this.$router.push({
          path: "/guide/index",
          query: {
            column_id: this.column_id,
            subject_id: this.subject_id
          },
        });
      }
    },

    goCes() {
      if (this.IsUsersLogin()) {
        this.$router.push({
          path: "/guide/ces/index",
          query: {
            column_id: this.column_id,
            subject_id: this.subject_id
          },
        });
      }
    },

    closeBox(e) {
      this.showLogin = false;
    },

    closeBoxColumn(e) {
      console.log(e);
      this.showColumn = false;
    },

    closeVipBox(e) {
      this.showVip = false;
    },

    lockChapter() {
      if (this.IsUsersLogin()) {
        //获取VIP列表
        let that = this;
        let formData = {};
        formData.column_id = that.column_id;
        that.axios.post("/getVip", formData).then((res) => {
          if (res) {
            that.vipData = res.data.info;
            console.log(that.vipData);
          }
        });
        this.showVip = true;
      }
    },

    //获取章节类别
    getChapterList() {
      let that = this;
      let formData = {};
      that.loading = true;
      formData.column_id = that.column_id;
      formData.subject_id = that.subject_id;
      that.axios.post("/getTestChapterList", formData).then((res) => {
        if (res) {
          that.columnName = res.data.column_name;
          that.subjectName = res.data.subject_name;
          that.chapterData = res.data.lists;
          that.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.chapter {
  width: 1200px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 90px;
}

.chapter .c_left {
  width: 20%;
  background: #fff;
  padding: 20px 0;
}

.chapter .c_left .title {
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}

.chapter .meaus {
  display: flex;
  flex-direction: column;
}

.chapter .meaus .li {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 60px;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
  border-left: 2px solid #ffffff;
}

.chapter .meaus .active {
  background: linear-gradient(90deg, #ffffff 0%, #f3f6ff 100%);
  color: #4171f9;
  border-left: 2px solid #4171f9;
}

.chapter .meaus .li:hover {
  background: linear-gradient(90deg, #ffffff 0%, #f3f6ff 100%);
  color: #4171f9;
  border-left: 2px solid #4171f9;
}

.chapter .meaus .li img {
  margin-right: 10px;
}

.chapter .c_right {
  width: 78%;
}

.chapter .c_right .buyType {
  background: #fff;
}

.chapter .c_right .buySubject {
  padding: 15px 20px 0px;
  border-bottom: 1px solid #f2f2f2;
}

.buySubject span {
  float: left;
  font-size: 18px;
  display: block;
  margin-top: 7px;
}

.buySubject a {
  cursor: pointer;
}

.buySubject a.active,
.buySubject a:hover {
  background: #badbff;
  color: #1167d4;
  border-radius: 5px;
}

.buySubject a {
  font-size: 14px;
  display: inline-block;
  padding: 8px 15px;
  margin: 0 0 15px 10px;
  color: #3f3f3f;
}

.mk_conbox {
  padding: 0 0 20px;
  display: flow-root;
  min-height: 500px;
}

.mk_conbox .tab_nav {
  background: #fff;
  margin-top: 10px;
  padding: 5px 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.mk_conbox .tab_nav .li {
  height: 52px;
  line-height: 52px;
  margin: 0 15px;
  font-size: 18px;
  cursor: pointer;
}

.mk_conbox .tab_nav .li.active {
  color: #4171f9;
  font-weight: bold;
  border-bottom: 3px solid #4171f9;
}

.marginTop20 {
  margin-top: 20px;
}

.tab-list {
  background-color: #fff;
  width: 100%;
  float: left;
}

.f-mt20 {
  margin-top: 20px;
}

.tab-list .hd {
  background-color: #f8f8f8;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
  z-index: 2;
  overflow: hidden;
}

.tab-list ul {
  border-bottom: 1px solid #f5f5f5;
}

.tab-list .w1 {
  width: 525px;
}

.tab-list li {
  float: left;
  line-height: 33px;
  text-align: center;
  cursor: pointer;
  list-style: none;
  width: 100%;
}

.tab-list .subject {
  line-height: 21px;
  padding: 10px 0;
  float: left;
  color: #999;
  background-color: #f9f9f9;
  width: 100%;
  font-size: 14px;
}

.tab-list .w2 {
  width: 80px;
  font-size: 12px;
  color: #999;
}

.tab-list .w3 {
  position: relative;
  width: 60px;
  font-size: 12px;
  color: #999;
}

.tab-list .w4 {
  display: inline;
  float: right;
  width: 145px;
  padding-right: 10px;
  text-align: right;
}

.tab-list .f-lf {
  font-size: 15px;
  line-height: 23px;
  text-align: left;
  position: relative;
}

.tab-list .f-lf a {
  display: block;
  z-index: 1;
}

.tab-list .f-lf em {
  background-image: url("../../../public/images/tk_gd.png");
  background-position: 0 -18px;
  background-repeat: no-repeat;
  display: block;
  height: 20px;
  left: 8px;
  position: absolute;
  top: 9px;
  width: 20px;
}

.tab-list .f-lf .develop {
  background-position: 0px -18px;
}

.tab-list .f-lf .unwind {
  background-position: -27px -18px;
}

.tab-list ul {
  border-bottom: 1px solid #f5f5f5;
}

.tab-list .bd {
  line-height: 21px;
  padding: 10px 15px;
  float: left;
  width: 100%;
}

.tab-list .f-lf i {
  font-size: 16px;
  display: block;
  float: left;
  font-style: normal;
  padding-left: 36px;
  padding-top: 7px;
  width: 89%;
}

.tab-list .progress {
  background-color: #ccc;
  display: block;
  float: left;
  height: 11px;
  line-height: 11px;
  margin-top: 10px;
  text-align: left;
  width: 100px;
}

.tab-list .progress-txt {
  color: #999;
  float: left;
  padding-left: 15px;
}

.tab-list .btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  display: inline-block;
  border-radius: 5px;
  background: linear-gradient(-90deg, #2874e0, #004bb3);
  box-shadow: 0 4px 10px 0 rgba(14, 80, 158, 0.3);
}

.tab-list .btn i {
  margin-right: 5px;
}

.tab-list .mksj_ckjx {
  right: 110px;
  background: linear-gradient(-90deg, #e0b16c, #dc9d31);
  box-shadow: 0 4px 10px 0 rgba(165, 122, 47, 0.3);
}

.tab-list .btn1 {
  color: #1167d4;
  display: block;
  margin: 0 auto;
  width: 70px;
}

.tab-list .level-1 {
  width: 525px;
}

.tab-list .f-lf .no-underclass {
  background-position: -183px -193px;
}

.screening dl::after {
  clear: both;
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
}

.screening dd a:hover {
  background-color: #1167d4;
  color: #fff;
}

.home_header {
  height: 70px;
  width: 100%;
  background: #fff;
  padding: 0 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.home_header .context_box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.home_header .context_box> :not(span):not(p) {
  padding-right: 20px;
}

.home_header .context_box>b {
  font-size: 26px;
  line-height: 65px;
  height: 70px;
}

.home_header .context_box>span {
  font-size: 18px;
  line-height: 18px;
  color: #666;
  padding-right: 10px;
}

.home_header .context_box>.check_box {
  position: relative;
}

.home_header .context_box> :not(span):not(p) {
  padding-right: 20px;
}

.el-dropdown {
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 14px;
}

.home_header .context_box>.check_box p {
  color: #fff;
  font-size: 14px;
  background: #4171f9;
  border-radius: 24px;
  line-height: 36px;
  padding: 0 12px;
  line-height: 28px;
  display: flex;
  align-items: center;
  font-style: normal;
  cursor: pointer;
}

.home_header .context_box>.check_box p>i {
  font-style: normal;
  margin-right: 5px;
}

.home_header .context_box>.check_box p>span {
  display: inline-block;
  width: 15px;
  height: 12px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAyCAYAAABcfPsmAAADm0lEQVRIie1WXWgUVxT+Tu6d3czEpEqqYjChjS8aQYUI+iCJCCKoRQsVoQ8VfLA+lIIovgR9FFFB+yAooiK+iaKBIIWi+EMR0ZY2TbAvWxHxIUlht+zGnd3ZmSMn3llnk9nNbpPSFz843N255373/Hz3zmC+QcyMVCqFjo4OjIyMwLZtZLNZ9PT0TI0TExMoFov9ra2tjuM4jzo7OyfFj4imQmlqakImk4HjOOjt7UVTXICyiWVZUEotYOazjuM8yOfzdwuFwvV0Ot2pta6aV+yMUkoiW+F53nki2sbMw5ZljU9OTn6Zy+W6bdveT0S/ysbTERuhbdt9Y2NjQ9lsdpvWeoiIthPRF1rrS0qptZ7n3QWwI27tDMIgCGT3wWQyuZKIzgHYA+ANAFcpdUApNeB53lJmvs3M38cSSoGVUpL+GWa+XCqVFiYSiYNa60PM7IbOvu+jvb39RFdX117P83wAPwC4wMx2BWEul/sslUrdsSzrMICXAPqVUhdloyAIyiaEiUQCbW1tN3zf3wTgRRAE37a0tAwqpT4vEwZBcCufz+8wUhgE8EgKHkojUg64rgvP8+TvLwB+FD+t9VYAN8tdJqK/lFLitQFAUbRVKBRkqpWIFpUloTXS6XQ6k8lkk8mkPJpiZuanAF5HmyKFHwjLEInsJIBXUWPmk5L6tKYOGI4KHZY7HtHXKjM+NGM/M6/CTJTXVpf8e5TMuDncK/IsFrMRhvi0Tr8KwrBwblhDZg6j+TsadWTenbY2NsJuY+IUdvhGZF6erTDpd8dGaJowTkR5AHuZuc/MLzfjnsiajcz8wPxeBiDPzOMVhHKXEdFoqVT62nXdfUqpT0zxn8c0Qda0yOj7/vPm5uZrWuvRUBkUdwX9W0htY6+vKngM4BmAxbWcGiFsBrAewP2apJJynbaYmf/g9xiWK2v6uijhY24cfXGE9Z6UiqQi9ZyB/7XLdSEklKv/rUmnHvsHwLq4DULC7+TtOZ8RXjFjEcAuczHUMjmav8UyRtp+yginwMzrGtBnVdkcNRfBwbmkTMl7T+rxWwngJwBXARyPTrhbNn4ga0A2UrelAI4BOF3LsV7CFwC+Mu/hI0ZmVQklnYk6tCdfFJZZ981sETZy/tLmIykW0uU/ASxpgLAm/pOzLHZbPv8aOMtDtVJeA2D3fEY4DOB383/U1HO2s7yzFmEAYKshW23Sn1OEMDrcAuBnAJm5EH7ERzQKAO8Ae6gWTMg17TEAAAAASUVORK5CYII=) 0 -18px;
}
</style>
